import { render, staticRenderFns } from "./riderWiseAverageReport_KSA_new.vue?vue&type=template&id=ec222d74&"
import script from "./riderWiseAverageReport_KSA_new.vue?vue&type=script&lang=js&"
export * from "./riderWiseAverageReport_KSA_new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports